import React from 'react';
import { Deal } from '../types/deal';
import { getCallout, PromoPage } from '../utils/dealImages';
import { useFirebaseImageUrl } from '../hooks/useFirebaseImageUrl';
import './CalloutCard.css';

interface CalloutCardProps {
  deal: Deal | null | undefined;
  page: PromoPage;
}

/**
 * Optional partner callout (icon + title + body) shown at the top of the promo
 * panel on the screens the deal enables. Renders nothing when not configured.
 */
const CalloutCard: React.FC<CalloutCardProps> = ({ deal, page }) => {
  const callout = getCallout(deal, page);
  const iconUrl = useFirebaseImageUrl(callout?.icon);

  if (!callout) return null;

  return (
    <div className="hp-callout">
      {iconUrl && <img src={iconUrl} alt="" className="hp-callout-icon" />}
      <div className="hp-callout-text">
        {callout.title && <p className="hp-callout-title">{callout.title}</p>}
        {callout.body && <p className="hp-callout-body">{callout.body}</p>}
      </div>
    </div>
  );
};

export default CalloutCard;
